import React from "react";
import { IVisual, Visual } from "../shared/Visual";

export const DynamicHero: React.FC<{
  firstAsset: IVisual;
  secondAsset: IVisual;
}> = ({ firstAsset, secondAsset }) => {
  return (
    <section className="relative grid md:grid-cols-2">
      <div className="aspect-h-1 aspect-w-1">
        <Visual
          visual={firstAsset}
          autoPlay
          muted
          loop
          className="object-cover"
          loading="eager"
          poster={`/image/vid_cover_2.webp`}
        />
      </div>
      <div className="aspect-h-1 aspect-w-1">
        <Visual
          visual={secondAsset}
          autoPlay
          muted
          loop
          className="object-cover"
          loading="eager"
          poster={`/image/vid_cover_1.webp`}
        />
      </div>
    </section>
  );
};
